import {
	HealthBookingEnum,
	TelehealthBookingEnum,
	OdontoBookingEnum,
	ExamBookingEnum,
	AuthorizationsEnum,
} from 'presentation/constants';
import {FlowEnum} from './flowEnum';

export const BOOKING_INITIAL_PATH: Record<
	Exclude<
		FlowEnum,
		FlowEnum.PROFILE | FlowEnum.HEALTH_GUIDE | FlowEnum.ODONTO_GUIDE | FlowEnum.SURGERY
	>,
	string
> = {
	[FlowEnum.HEALTH]: HealthBookingEnum.HEALTH_BOOKING_INITIAL,
	[FlowEnum.TELEHEALTH]: TelehealthBookingEnum.TELEHEALTH_BOOKING_INITIAL,
	[FlowEnum.ODONTO]: OdontoBookingEnum.ODONTO_BOOKING_INITIAL,
	[FlowEnum.EXAM]: ExamBookingEnum.EXAM_BOOKING_INITIAL,
	[FlowEnum.AUTHORIZATIONS]: AuthorizationsEnum.REQUEST,
};
